const isProdMode = Object.is(process.env.NODE_ENV, 'production');
module.exports = {
    baseUrl: isProdMode ? 'https://d3p7dprvnplsp5.cloudfront.net/pc' : 'https://d3p7dprvnplsp5.cloudfront.net/pc'
};
